if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          Alpine.store("xHeaderMenu")?.suppressScroll?.();
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async addToCart(e, required, quickView, sticky) {
          this.loading = true;         
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      Alpine.store("xHeaderMenu")?.suppressScroll?.();
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              

                if (!this.stopAction) {
                  productInfo.querySelectorAll('.recipient_input').forEach(giftCardInput => {
                    if (!this.stopAction && giftCardInput.required) {
                      this.stopAction = Alpine.$data(giftCardInput.closest('[x-data]')).onChangeInput(giftCardInput);
                      if (this.stopAction) {
                        Alpine.store("xHeaderMenu")?.suppressScroll?.();
                        giftCardInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }
                    }
                  });
                }
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            await Alpine.store('xCartHelper').waitForCartUpdate();
            window.updatingCart = true;

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            if (window.TSNProductAddOns && typeof window.TSNProductAddOns.prepareForm === 'function') {
              window.TSNProductAddOns.prepareForm(this.$refs.product_form);
            }
            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            let hasTsnProductAddOns = false;
            let isAddAsBundleProduct = false;
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');
            const linkedProductListQty = newFormData.getAll('properties[_linked_product_id_qty][]');
            hasTsnProductAddOns = window.TSNProductAddOns && typeof window.TSNProductAddOns.hasSelectedAddOns === 'function' && window.TSNProductAddOns.hasSelectedAddOns(this.$refs.product_form);
            isAddAsBundleProduct = (quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'));
            const isTsnMainBundleProduct = hasTsnProductAddOns
              && typeof window.TSNProductAddOns.mainProductHasComponents === 'function'
              && window.TSNProductAddOns.mainProductHasComponents(this.$refs.product_form);
            let tsnProductAddOnData = [];
            let tsnProductAddOnDataForSeparateAdd = [];
            const appendCartItem = (targetFormData, item, index) => {
              const base = `items[${index}]`;

              targetFormData.append(`${base}[id]`, item.id);
              targetFormData.append(`${base}[quantity]`, item.quantity);

              if (item.selling_plan) {
                targetFormData.append(`${base}[selling_plan]`, item.selling_plan);
              }

                if (item.parent_id) {
                  targetFormData.append(`${base}[parent_id]`, item.parent_id);
                }

              if (item.properties) {
                Object.entries(item.properties).forEach(([key, value]) => {
                  targetFormData.append(`${base}[properties][${key}]`, value);
                })
              }
            };
            const buildCleanFormData = (sourceFormData) => {
              const cleanFormData = new FormData();

              for (let [key, value] of sourceFormData.entries()) {
                if (value !== '') {
                  cleanFormData.append(key, value);
                }
              }

              return cleanFormData;
            };
            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) || 
              (linkedProductList.length > 0) ||
              (linkedProductListQty.length > 0) ||
              hasTsnProductAddOns
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              const getMainCartItem = () => {
                const mainItem = {
                  id: variantId,
                  quantity: formData.get('quantity') || 1
                };
                const sellingPlan = formData.get('selling_plan');
                const properties = {};

                if (sellingPlan) {
                  mainItem.selling_plan = sellingPlan;
                }

                for (let [key, value] of formData.entries()) {
                  const propertyName = key.match(/^properties\[(.+)\]$/)?.[1];
                  if (propertyName && value !== '' && !propertyName.startsWith('_linked_product_id')) {
                    properties[propertyName] = value;
                  }
                }

                if (Object.keys(properties).length > 0) {
                  mainItem.properties = properties;
                }

                return mainItem;
              };
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductListQty.length > 0) {
                let qty = newFormData.get('quantity');
                linkedProductListQty.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: qty,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }

              if (hasTsnProductAddOns && typeof window.TSNProductAddOns.getSelectedItems === 'function') {
                const addTsnAddOnsSeparately = isTsnMainBundleProduct;
                const addOnOptions = {
                  parentVariantId: variantId,
                  parentProductId: productId,
                  parentTitle: productTitle,
                  useParentId: !addTsnAddOnsSeparately
                };

                tsnProductAddOnData = window.TSNProductAddOns.getSelectedItems(this.$refs.product_form, addOnOptions);
                if (addTsnAddOnsSeparately) {
                  tsnProductAddOnDataForSeparateAdd = tsnProductAddOnData.map((item) => {
                    const separateItem = { ...item };
                    delete separateItem.parent_id;
                    return separateItem;
                  });
                } else {
                  tsnProductAddOnData.forEach((item) => additionalOptionData.push(item));
                }
              }
              
              if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) {
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                if (hasTsnProductAddOns && isAddAsBundleProduct) {
                  newFormData.delete('id');
                  newFormData.delete('quantity');
                  newFormData.delete('selling_plan');

                  for (let [key] of formData.entries()) {
                    if (key.startsWith('properties[')) {
                      newFormData.delete(key);
                    }
                  }

                  additionalOptionData.unshift(getMainCartItem());
                }

                additionalOptionData.forEach((item, index) => {
                  appendCartItem(newFormData, item, index);
                })
              }
            }

            let resProductId;

            const addToCartRequest = async (body) => {
              const response = await fetch(`${Eurus.cart_add_url}`, {
                method:'POST',
                headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
                body
              });

              return response.json();
            };
            const shouldRetryBundleAddOnsSeparately = (response) => {
              return hasTsnProductAddOns
                && tsnProductAddOnDataForSeparateAdd.length > 0
                && response?.status == '422'
                && /bundle products and add-ons cannot be mixed|cannot reference existing parent lines by variant_id/i.test(response.description || '');
            };

            try {
              let response = await addToCartRequest(newFormData);
              let tsnProductAddOnsAddedSeparately = false;

              if (shouldRetryBundleAddOnsSeparately(response)) {
                const mainProductResponse = await addToCartRequest(buildCleanFormData(formData));

                if (mainProductResponse.status == '422') {
                  response = mainProductResponse;
                } else {
                  const addOnsOnlyFormData = new FormData();
                  addOnsOnlyFormData.append(
                    'sections',
                    Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                  );
                  addOnsOnlyFormData.append('sections_url', window.location.pathname);
                  tsnProductAddOnDataForSeparateAdd.forEach((item, index) => {
                    appendCartItem(addOnsOnlyFormData, item, index);
                  });

                  const addOnsResponse = await addToCartRequest(addOnsOnlyFormData);
                  tsnProductAddOnsAddedSeparately = addOnsResponse.status != '422';
                  response = addOnsResponse.status == '422' ? addOnsResponse : mainProductResponse;
                  if (addOnsResponse.sections) {
                    response.sections = addOnsResponse.sections;
                  }
                }
              }

              if (response.status != '422' && hasTsnProductAddOns && tsnProductAddOnDataForSeparateAdd.length > 0 && !tsnProductAddOnsAddedSeparately) {
                const addOnsOnlyFormData = new FormData();
                addOnsOnlyFormData.append(
                  'sections',
                  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                );
                addOnsOnlyFormData.append('sections_url', window.location.pathname);
                tsnProductAddOnDataForSeparateAdd.forEach((item, index) => {
                  appendCartItem(addOnsOnlyFormData, item, index);
                });

                const addOnsResponse = await addToCartRequest(addOnsOnlyFormData);
                if (addOnsResponse.status == '422') {
                  response = addOnsResponse;
                } else if (addOnsResponse.sections) {
                  response.sections = addOnsResponse.sections;
                }
              }

              if (response.status == '422') {
                document.dispatchEvent(new CustomEvent("eurus:product:add-failed", {
                  detail: {
                    errorMessage: response.description
                  }
                }));
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              } else {
                resProductId = response.product_id;

                if (this.$refs.product_form) {
                  document.dispatchEvent(new CustomEvent(`eurus:cart:custom-options:reset:${this.$refs.product_form.getAttribute('id')}`));
                }

                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};
      
                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();
                document.dispatchEvent(new CustomEvent("eurus:video-popup:close-popup"));
                if(!hasTsnProductAddOns && isAddAsBundleProduct) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  Alpine.store('xCartHelper').reRenderSections(response.sections);
                  if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                    Alpine.store('xMiniCart').openCart();
                  }               
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
                  if (Alpine.store('xQuickView')) {
                    Alpine.store('xQuickView').openPopupMobile = false;
                  }
                  this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                  this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                  document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                  document.dispatchEvent(new CustomEvent("eurus:product:added", {
                    detail: {
                      product: response
                    }
                  }));
                }
              }
            } catch (error) {
              document.dispatchEvent(new CustomEvent("eurus:product:add-failed", {
                detail: {
                  errorMessage: error
                }
              }));
              console.error('Error:', error);
            } finally {
              window.updatingCart = false;
              document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${resProductId}`));
              this.loading = false;
              if (!isAddAsBundleProduct || hasTsnProductAddOns) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            }
          }, 0)
        }
      }))
    });
}
